import { useCallback } from 'react';

import { usePreviewPintoWriterCampaignOgImageMutation } from '../core/graphql/operation-hooks';
import { PreviewPintoProductCampaignOgImageInput } from '../core/graphql/types';

const useMutationPreviewPintoWriterCampaignOgImage = () => {
  const [mutatePreviewPintoWriterCampaignOgImage, { loading: isLoadingMutatePreviewPintoWriterCampaignOgImage }] = usePreviewPintoWriterCampaignOgImageMutation();

  const onMutatePreviewPintoWriterCampaignOgImage = useCallback(
    (input: PreviewPintoProductCampaignOgImageInput) => {
      const variables = { input };
      return mutatePreviewPintoWriterCampaignOgImage({ variables });
    },
    [mutatePreviewPintoWriterCampaignOgImage],
  );

  return {
    onMutatePreviewPintoWriterCampaignOgImage,
    isLoadingMutatePreviewPintoWriterCampaignOgImage,
  };
};

export default useMutationPreviewPintoWriterCampaignOgImage;
